var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [
          _c("v-tab", { attrs: { href: "#tab-1" } }, [
            _vm._v("Auditoría Clientes")
          ])
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "fieldset",
        {
          staticStyle: {
            width: "100%",
            "margin-bottom": "20px",
            display: "flex",
            height: "95%",
            border: "1px solid rgb(220, 220, 220)"
          }
        },
        [
          _c(
            "legend",
            {
              staticStyle: {
                "margin-left": "0.3rem",
                color: "#9e9e9e",
                "font-size": "0.8rem"
              }
            },
            [_vm._v("\n      Buscar\n    ")]
          ),
          _c(
            "v-form",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "center",
                width: "100%"
              },
              model: {
                value: _vm.isFormValid,
                callback: function($$v) {
                  _vm.isFormValid = $$v
                },
                expression: "isFormValid"
              }
            },
            [
              _c(
                "FormFieldsContainer",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center",
                    width: "100%"
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { margin: "20px", width: "50%" } },
                    [
                      _c("v-autocomplete", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          items: _vm.usuarios,
                          label: "Usuario",
                          required: "",
                          chips: "",
                          "deletable-chips": "",
                          "item-text": "nombreCompleto",
                          "item-value": "email",
                          dense: "",
                          "data-vv-name": "usuarioRequerido",
                          "error-messages": _vm.errors.collect(
                            "usuarioRequerido"
                          )
                        },
                        model: {
                          value: _vm.usuarioSeleccionado,
                          callback: function($$v) {
                            _vm.usuarioSeleccionado = $$v
                          },
                          expression: "usuarioSeleccionado"
                        }
                      }),
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.eventos,
                          label: "Tipo Evento",
                          required: "",
                          chips: "",
                          "deletable-chips": "",
                          "item-text": "nom",
                          "item-value": "cod",
                          dense: ""
                        },
                        model: {
                          value: _vm.eventoSeleccionado,
                          callback: function($$v) {
                            _vm.eventoSeleccionado = $$v
                          },
                          expression: "eventoSeleccionado"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "20px",
                            "margin-bottom": "0px"
                          }
                        },
                        [
                          _c("DatePicker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              label: "Fecha Inicio",
                              max: _vm.fechaMaxima
                            },
                            model: {
                              value: _vm.fechaDesde,
                              callback: function($$v) {
                                _vm.fechaDesde = $$v
                              },
                              expression: "fechaDesde"
                            }
                          }),
                          _c("TimePicker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { label: "Hora Inicio" },
                            model: {
                              value: _vm.horaDesde,
                              callback: function($$v) {
                                _vm.horaDesde = $$v
                              },
                              expression: "horaDesde"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "20px",
                            "margin-bottom": "0px"
                          }
                        },
                        [
                          _c("DatePicker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { label: "Fecha Fin", max: _vm.fechaMaxima },
                            model: {
                              value: _vm.fechaHasta,
                              callback: function($$v) {
                                _vm.fechaHasta = $$v
                              },
                              expression: "fechaHasta"
                            }
                          }),
                          _c("TimePicker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { label: "Hora Fin" },
                            model: {
                              value: _vm.horaHasta,
                              callback: function($$v) {
                                _vm.horaHasta = $$v
                              },
                              expression: "horaHasta"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "center"
                        }
                      },
                      [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "center"
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "#FFE700" },
                                  on: {
                                    click: function($event) {
                                      return _vm.buscar()
                                    }
                                  }
                                },
                                [_vm._v("Buscar")]
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "gridcard rounded-card",
          staticStyle: { "margin-top": "10px" }
        },
        [
          _c("ag-grid-vue", {
            staticClass: "ag-theme-material",
            staticStyle: {
              width: "100%",
              height: "400px",
              "font-family": "'Asap', sans-serif"
            },
            attrs: { gridOptions: _vm.gridOptions }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }